import React from 'react';
import { ArrowRightIcon, LockKeyholeIcon, ShieldCheckIcon } from 'lucide-react';
interface ActionButtonProps {
  children: React.ReactNode;
  href?: string;
  showTrust?: boolean;
  className?: string;
}
export const checkoutUrl = 'https://kit-expresion-corporal-consciente.impultienda.ar/checkout';
export function ActionButton({
  children,
  href = checkoutUrl,
  showTrust = false,
  className = ''
}: ActionButtonProps) {
  const handleClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    if (href !== '#pricing') return;
    event.preventDefault();
    const destination = document.getElementById('pricing');
    if (!destination) return;
    const start = window.scrollY;
    const target = destination.getBoundingClientRect().top + start;
    const duration = 360;
    const startTime = performance.now();
    const step = (time: number) => {
      const progress = Math.min((time - startTime) / duration, 1);
      const eased = 1 - Math.pow(1 - progress, 4);
      window.scrollTo(0, start + (target - start) * eased);
      if (progress < 1) window.requestAnimationFrame(step);
    };
    window.requestAnimationFrame(step);
  };
  return <div className={className} data-id="element-12" data-mp="2b4k0bicau02p">
      <a href={href} onClick={handleClick} className="group inline-flex w-full items-center justify-center gap-2 rounded-full bg-primary px-6 py-4 text-center font-display text-base font-bold text-foreground shadow-cta transition-colors duration-150 ease-out hover:bg-primary-soft hover:text-canvas sm:text-lg" data-id="element-13" data-mp="2g10ogcji0efs">
        {children}
        <ArrowRightIcon className="h-5 w-5 shrink-0 transition-transform duration-150 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-14" data-mp="1scr7bnx8ceuz" />
      </a>
      {showTrust && <div className="mt-3 flex flex-wrap justify-center gap-x-4 gap-y-2 text-xs text-foreground-subtle" data-id="element-15" data-mp="222arcwwoierf">
          <span className="inline-flex items-center gap-1.5" data-id="element-16" data-mp="14n6nl2t95dkn">
            <ShieldCheckIcon className="h-3.5 w-3.5 text-primary-soft" data-id="element-17" data-mp="14kkf90yjeu1d" />
            Garantía 30 días
          </span>
          <span className="inline-flex items-center gap-1.5" data-id="element-18" data-mp="11kimvfa9un0r">
            <LockKeyholeIcon className="h-3.5 w-3.5" data-id="element-19" data-mp="11iz8xvc38o25" />
            Pago seguro
          </span>
          <span data-id="element-20" data-mp="wlfh1smgwcrq">Mercado Pago</span>
        </div>}
    </div>;
}